import React from "react";
import { useSearchParams } from "react-router-dom";
import { BACKEND_URL } from "../../lib/api";

export default function AdminLoginPage() {
  const [params] = useSearchParams();
  const error = params.get("error");

  const handleLogin = () => {
    window.location.href = `${BACKEND_URL}/api/auth/google`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-navy-900">
      {/* subtle radial glow behind card */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[500px] h-[500px] rounded-full bg-gold/5 blur-3xl" />
      </div>

      <div className="relative w-full max-w-sm">
        {/* card */}
        <div className="bg-navy-800 rounded-3xl overflow-hidden border border-gold/20 shadow-2xl">

          {/* gold top bar */}
          <div className="h-1 w-full bg-gradient-to-r from-transparent via-gold to-transparent" />

          <div className="px-8 pt-10 pb-8 flex flex-col items-center text-center">

            {/* logo */}
            <img src="/logo.png" alt="GamesTrade" className="h-16 w-auto mb-4 drop-shadow-lg" />
            <div className="font-black text-3xl tracking-tighter leading-none mb-1">
              GAMES<span className="text-gold">TRADE</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-8">Admin Console</div>

            {/* divider */}
            <div className="w-full border-t border-white/5 mb-8" />

            <h2 className="text-lg font-extrabold uppercase tracking-wider mb-1">Welcome back</h2>
            <p className="text-slate-400 text-xs leading-relaxed mb-6">
              Sign in with your authorised Google account<br />to access the GamesTrade dashboard.
            </p>

            {error && (
              <div className="w-full mb-4 bg-rose-500/10 border border-rose-500/30 text-rose-300 text-xs rounded-xl p-3" data-testid="login-error">
                {decodeURIComponent(error)}
              </div>
            )}

            <button
              onClick={handleLogin}
              data-testid="google-signin-btn"
              className="w-full flex items-center justify-center gap-3 bg-gold hover:bg-gold-light text-navy-900 font-extrabold uppercase tracking-widest text-sm py-4 rounded-2xl btn-glow transition-all"
            >
              <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google
            </button>

            <p className="text-[10px] text-slate-600 mt-5">Restricted to authorised accounts only.</p>
          </div>

          {/* gold bottom bar */}
          <div className="h-1 w-full bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
        </div>
      </div>
    </div>
  );
}
